import { TextLink } from 'braid-design-system';
import type React from 'react';

import type { LabelLink } from './types.ts';

export const parseLabel = (id: string, label: string, links?: LabelLink[]) => {
  if (!links?.length) {
    return label;
  }

  const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
  const matches = Array.from(label.matchAll(linkRegex));

  const validMatches = matches.filter((match) =>
    links.some((link) => link.text === match[1]),
  );

  if (validMatches.length === 0) {
    return label;
  }

  const labelParts: React.ReactNode[] = [];
  let lastIndex = 0;

  validMatches.forEach((match, index) => {
    const [fullMatch, linkText] = match;
    const linkConfig = links.find((link) => link.text === linkText);
    if (!linkConfig) {
      return;
    }

    if (match.index! > lastIndex) {
      labelParts.push(label.slice(lastIndex, match.index));
    }

    labelParts.push(
      <TextLink
        key={`${id}-link-${index}`}
        href={linkConfig.url}
        target={linkConfig.target}
        hitArea={linkConfig.hitArea}
      >
        {linkText}
      </TextLink>,
    );

    lastIndex = match.index! + fullMatch.length;
  });

  if (lastIndex < label.length) {
    labelParts.push(label.slice(lastIndex));
  }

  return <>{labelParts}</>;
};
